// Acao padrao dos CTAs de "demonstracao / falar com o time".
// Enquanto nao houver webchat/CRM conectado, abrimos um e-mail pre-preenchido.
// Centralizado aqui para trocar por um formulario ou widget no futuro sem mexer
// em cada componente.

export const CONTACT_EMAIL = 'comercial@libbenincorp.com';

const SUBJECT = 'Quero uma demonstracao do LibbenIncorp';
const BODY =
  'Ola! Tenho interesse em conhecer o LibbenIncorp para minha incorporadora.\n\n' +
  'Nome:\n' +
  'Incorporadora:\n' +
  'Numero de empreendimentos ativos:\n' +
  'Telefone / WhatsApp:\n';

export function openContact(event) {
  if (event && typeof event.preventDefault === 'function') event.preventDefault();
  const url = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(SUBJECT)}&body=${encodeURIComponent(BODY)}`;
  if (typeof window !== 'undefined') window.location.href = url;
}
